var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-formbar',[_c('div',{staticClass:"hide"},[_c('div',{staticClass:"itens"}),_c('div',{staticClass:"actions"})])])}
var staticRenderFns = []

export { render, staticRenderFns }